import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Card, Form, Button } from "antd";
import ExcelProcess from "./standard-time-staff-excel-process";
import { API_BASE } from "../../utils/contrains";

const Item = Form.Item;
class StandardTimeStaffImportModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    item: PropTypes.object.isRequired,
    creator: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    item: {
      attacheFileUrl: "",
    },
  };

  constructor(props) {
    super(props);

    this.get_files = React.createRef();
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {}

  handle_data_download = (fileUrl) => {
    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "範例清單";
    a.click();
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { uid, attacheFileUrl } = this.state.item;
    const fileUploadUrlPath = "/api/ExtraExcelProcess/File";
    const fileDownloadUrlPath = "/Templates/StandardTimeDateList.xls";
    const sourceFile =
      attacheFileUrl === ""
        ? []
        : [
            {
              Uid: uid,
              FileNewName: "檔案已處理",
              FileUrl: attacheFileUrl,
            },
          ];
    return (
      <Card>
        <Form>
          <Item label="上傳檔案">
            <ExcelProcess
              ref={this.get_files}
              data_source={sourceFile}
              api_url={fileUploadUrlPath}
              data_info={this.props.item}
              creator={this.props.creator}
            ></ExcelProcess>
          </Item>
          <Item label="範例格式">
            <Button
              type="primary"
              onClick={() => this.handle_data_download(fileDownloadUrlPath)}
            >
              <i className="fas fa-file-download"></i>
              <span style={{ marginLeft: "4px" }}> 下載</span>
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StandardTimeStaffImportModal);
